import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import ImageGrid from './filters/ImageGrid';
import IconButton from '@material-ui/core/IconButton';
import { gsap } from 'gsap';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
const styles = () => ({});

class ArtworksList extends Component {
  constructor(props) {
    super(props);
    this.loadedArtworks = props.loadedArtworks;
    this.state = { loadedArtworks: props.loadedArtworks };
  }

  componentDidMount() {
    this.openList();
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.loadedArtworks) !==
      JSON.stringify(this.props.loadedArtworks)
    ) {
      this.setState(
        {
          loadedArtworks: this.props.loadedArtworks,
        },
        () => {
          this.openList();
        },
      );
    }
  }

  openList() {
    gsap.to(this.rightCol, { right: 0, duration: 0.45 });
    gsap.to(this.closeBtn, { right: 320, duration: 0.65 });
  }

  render() {
    const { classes } = this.props;
    const { loadedArtworks } = this.state;
    const currentData = loadedArtworks;

    if (!currentData) {
      return <></>;
    } else {
    }

    return (
      <>
        <>
          <div
            id="artworks-drawer-list-gallery"
            className={classes.imagesContainer}
            ref={(c) => (this.rightCol = c)}
          >
            <div
              ref={(c) => (this.closeBtn = c)}
              id={'artworks-drawer-list-gallery-close'}
            >
              <IconButton
                aria-label="close"
                className={classes.iconHeader}
                id={'artworks-list-close'}
                onClick={() => {
                  this.props.onCloseHandler();
                }}
              >
                <NavigateNextIcon fontSize="large" />
              </IconButton>
            </div>
            <div id={'artworks-drawer-list-gallery-grid'}>
              <ImageGrid
                cols={1}
                onItemClickHandler={(result) => {
                  this.props.onArtworkListItemHandler(result);
                }}
                dragEnabled={false}
                data={currentData}
                dataIndex={0}
              />
            </div>
          </div>
        </>
      </>
    );
  }
}

export default withStyles(styles)(ArtworksList);
